var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center c-pointer justify-content-between",on:{"click":function($event){_vm.onClick ? _vm.onClick(_vm.name) : null}}},[_c('div',{staticClass:"text-truncate"},[_vm._v(_vm._s(_vm.label))]),_c('div',{class:{ 'border border-color-black-500 rounded-3 p-2 justify-content-center align-items-center ms-2': true, 'bg-black-500': _vm.populated }},[_c('div',{class:{
        'background-image w-12px h-12px mx-auto': true,
        'filter-icon': !_vm.populated,
        'filter-icon filter-invert': _vm.populated
      }})])])
}
var staticRenderFns = []

export { render, staticRenderFns }